<template>
  <div class="app-datepicker" :class="{'app-datepicker_has-error': danger}">
    <label :for="`datepicker-${_uid}`" class="app-datepicker__label" v-if="label">{{ label }}</label>
    <datepicker
      ref="input"
      class=""
      :id="`datepicker-${_uid}`"
      :format="format"
      :minimumView="minimumView"
      :maximumView="maximumView"
      :value="valueX"
      :typeable="typeable"
      :acceptable="acceptable"
      mondayFirst
      inBody
      @selected="valueX = $event"
      v-bind="$attrs"
    />
    <transition name="fade">
      <div class="app-input__validation-error" v-if="danger && dangerText.length">
        {{ dangerText }}
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name:     "AppDatepicker",
  props:    {
    value:       {},
    label:       {},
    danger:      {
      type:    Boolean,
      default: false,
    },
    dangerText:  {
      type:    String,
      default: "",
    },
    format:      {
      type:    String,
      default: 'dd.MM.yyyy',
    },
    minimumView: {
      type:    String,
      default: 'day',
    },
    maximumView: {
      type:    String,
      default: 'year',
    },
    typeable:    {
      type:    Boolean,
      default: false,
    },
    acceptable:  {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    valueX: {
      get() {
        return this.value;
      },
      set( v ) {
        this.$emit('input', v);
        this.$emit('update:danger', false);

      },
    },
  },
  methods:  {
    focus() {
      this.$refs.input.$el.querySelector('input').focus();
    },
    close() {
      this.$refs.input.close();
    },
  },
  mounted() {
    // const { input } = this.$refs;
    // input.$el.querySelector('input').addEventListener('focus', ( e ) => {
    //   setTimeout(() => {
    //     console.log(input.datepicker, input.datepicker.isOpen);
    //   }, 100);
    //   // if (!input.datepicker.isOpen) input.datepicker.showCalendar();
    //
    // });
  },
};
</script>

<style lang="scss">
.app-datepicker {
  position: relative;

  &__label {
    //color: #627084;
    //font-size: 1rem;
    font-size: .85rem;
    margin-bottom: 2px;
    display: block;
  }

  .vdp-datepicker {
    input {
      appearance: none;
      display: block;
      width: 100%;
      max-width: 100%;
      padding: 9px 10px;
      font: inherit;
      font-size: 1rem;
      border-radius: 4px;
      height: 100%;
      border: 1px solid #ced4da;
      color: inherit;

      &::placeholder {
        opacity: .5;
      }
    }
  }

  &_has-error {
    .vdp-datepicker {
      input {
        border-color: rgba(var(--app-danger), 1);
      }
    }
  }


}
</style>
